import { create } from "zustand";
import { StoreProfileProps } from "./interface/profile.interface";
import { getProfile } from "src/services/authen.service";
import { QueryGetProfile } from "src/entity/profile/profile.entity";
import { persist } from "zustand/middleware";
import { Company } from "src/entity/map-company-user/map-company-user";
import { cutOffMenusForNV } from "src/utils/find-permissions";

export const profileStore = create<StoreProfileProps>()(
  persist(
    (set) => ({
      loading: false,
      profile: null,
      error: null,
      clearProfile: () => set(() => ({ profile: null })),
      setCompanyIntoProfile: (company: Company) =>
        set((state) => ({ profile: state.profile ? { ...state.profile, activeCompany: company } : null })),
      requestProfile: async (query: QueryGetProfile) => {
        set(() => ({ loading: true }));
        try {
          const res = await getProfile(query);
          // console.log("respone get profile : ", res);
          const newMenus = res?.data?.isSystemAdmin ? res.data.menus : cutOffMenusForNV(res?.data?.menus);
          // console.log("New menus : ", newMenus);
          const newProfile = { ...res?.data };
          newProfile.menus = newMenus;
          set(() => ({ loading: false, profile: newProfile, error: null }));
          return res.data;
        } catch (err: any) {
          set(() => ({ loading: false, error: err?.message, profile: null }));
        }
      },
    }),
    {
      name: "profile-store",
    },
  ),
);
